/* ══════════════════════════════════════════════════════════
   PureEthical — pe-product-card.js v8
   Gymshark-style: wishlist + quick-add bottom sheet + cart
   ══════════════════════════════════════════════════════════ */

(function() {
'use strict';

/* ── Toast ── */
function msg(text) {
  var existing = document.querySelector('.pe-toast-msg');
  if (existing) existing.remove();
  var t = document.createElement('div');
  t.className = 'pe-toast-msg';
  t.setAttribute('role', 'status'); /* v30 Fase 1J: anunciado por leitores de ecra; o texto entra depois do aviso estar na pagina */
  t.setAttribute('aria-live', 'polite');
  t.style.cssText = 'position:fixed;bottom:80px;left:50%;transform:translateX(-50%);background:#111111;color:#fff;padding:10px 20px;border-radius:0;font-size:13px;z-index:9999;pointer-events:none;white-space:nowrap;box-shadow:0 4px 20px rgba(0,0,0,.2);';
  document.body.appendChild(t);
  setTimeout(function() { t.textContent = text; }, 60);
  setTimeout(function() { if (t.parentNode) t.remove(); }, 2500);
}

/* ── Wishlist (stores full product data) ── */
var WL_KEY = 'pe_wl_v2';
function getWL() { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch(e) { return []; } }
function saveWL(a) { try { localStorage.setItem(WL_KEY, JSON.stringify(a)); } catch(e) {} }

function getArticleData(el) {
  var a = el.closest('article, .product-card');
  if (!a) return null;
  return {
    pid:   String(a.dataset.pid || ''),
    title: a.dataset.title || '',
    price: a.dataset.price || '',
    img:   a.dataset.img   || '',
    url:   a.dataset.url || '#',
    /* v30 Fase 1G: a marca passa a ser guardada para aparecer nos favoritos (os ja guardados ficam como estao) */
    vendor: ((a.querySelector('.gs-subtitle') || a.querySelector('.pc-brand') || {}).textContent || '').trim()
  };
}

function syncWL() {
  var wl  = getWL();
  var ids = wl.map(function(p) { return String(typeof p === 'object' ? p.pid : p); });
  document.querySelectorAll('.pc-wish').forEach(function(b) {
    var on = ids.indexOf(String(b.dataset.pid)) > -1;
    b.classList.toggle('active', on);
    b.setAttribute('aria-pressed', String(on));
    var svg = b.querySelector('svg');
    if (svg) { svg.style.fill = on ? '#111111' : 'none'; svg.style.stroke = '#111111'; }
  });
  var badge = document.getElementById('wlBadge');
  if (badge) { badge.textContent = wl.length || ''; badge.classList.toggle('show', wl.length > 0); }
}
window.syncWishlistUI = syncWL;

/* Wishlist click — CAPTURE phase so fires before any stopPropagation */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.pc-wish');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  var pid = String(btn.dataset.pid || '');
  if (!pid) return;
  var wl  = getWL();
  var ids = wl.map(function(p) { return String(typeof p === 'object' ? p.pid : p); });
  var idx = ids.indexOf(pid);
  if (idx > -1) {
    wl.splice(idx, 1);
    msg(window.PE_T('removed_wishlist','Removed from wishlist'));
  } else {
    var data = getArticleData(btn);
    wl.push(data || pid);
    msg((window.PE_T?window.PE_T('saved','Saved'):'Saved'));
  }
  saveWL(wl);
  syncWL();
  if (window.renderWishlistDrawer) renderWishlistDrawer();
}, true); /* capture=true */

/* ── Backdrop for size panel ── */
var backdrop = null;
function getBackdrop() {
  if (!backdrop) {
    backdrop = document.createElement('div');
    backdrop.className = 'pc-sizes-backdrop';
    backdrop.addEventListener('click', closeAllPanels);
    document.body.appendChild(backdrop);
  }
  return backdrop;
}
function closeAllPanels() {
  document.querySelectorAll('.pc-sizes.pc-sizes--open').forEach(function(p) {
    p.classList.remove('pc-sizes--open');
  });
  document.querySelectorAll('[data-qa][aria-expanded="true"]').forEach(function(q) {
    q.setAttribute('aria-expanded', 'false');
  });
  var bd = document.querySelector('.pc-sizes-backdrop');
  if (bd) bd.classList.remove('open');
}

/* ── Quick-Add + → Gymshark Modal (mobile only) ──
   Extracted into a function so both [data-qa] elements AND .pc-qa-bar
   (the "Add" button) can trigger the exact same proper size-picker
   modal, instead of .pc-qa-bar silently adding whichever variant
   happened to be first in the list without asking. */
function openQuickAddModal(card) {
  if (!card) return false;

  var title   = card.dataset.title   || '';
  var price   = card.dataset.price   || '';
  var img     = card.dataset.img     || '';
  var vendor  = card.dataset.vendor  || '';

  var modal   = document.getElementById('qaModal');
  var overlay = document.getElementById('qaOverlay');
  if (!modal || !overlay) return false;

  document.getElementById('qaTitle').textContent  = title;
  document.getElementById('qaPrice').textContent  = price;
  document.getElementById('qaVendor').textContent = vendor;
  document.getElementById('qaImg').src = img;
  document.getElementById('qaImg').alt = title;

  var colorEl = document.getElementById('qaColor');
  var panel   = card.querySelector('.pc-sizes');
  var colorSw = card.querySelector('.pc-color-dot');
  colorEl.textContent = colorSw ? colorSw.dataset.colorName || '' : '';

  var sizesEl = document.getElementById('qaSizes');
  sizesEl.innerHTML = '';

  if (panel) {
    var szBtns = panel.querySelectorAll('.pc-sz:not(.pc-sz-more)');
    if (szBtns.length > 0) {
      szBtns.forEach(function(btn) {
        var row = document.createElement('div');
        var oos = btn.classList.contains('pc-sz-oos');
        var qv = parseInt(btn.dataset.vid,10)||0;
        var qcv = peCardVariant(card, btn.dataset.raw != null ? btn.dataset.raw : btn.dataset.sz); /* v34: cor do cartao */
        if (qcv === 0) oos = true; else if (qcv) qv = qcv;
        row.style.cssText = 'display:flex;align-items:center;justify-content:space-between;padding:14px 0;border-bottom:1px solid #e5e5ea;';
        row.innerHTML =
          '<span style="font-size:15px;font-weight:500;color:' + (oos ? '#ccc' : '#111111') + ';">' + String(btn.dataset.sz||'').replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}) + '</span>' +
          (oos
            ? '<span style="font-size:12px;color:#6b6b6b;">'+((window.PE_T&&PE_T('sold_out','Esgotado'))||'Esgotado')+'</span>'
            : '<button class="qa-sz-add" data-vid="' + qv + '" style="display:flex;align-items:center;gap:8px;background:none;border:none;cursor:pointer;font-size:13px;font-weight:600;color:#111111;font-family:var(--fb);">Add to bag <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg></button>');
        sizesEl.appendChild(row);
      });
    } else {
      var atcBtn = panel.querySelector('.pc-sizes-atc');
      if (atcBtn) {
        var row2 = document.createElement('div');
        row2.innerHTML = '<button class="qa-sz-add" data-vid="' + (parseInt(atcBtn.dataset.atc,10)||0) + '" style="width:100%;padding:16px;background:#000000;color:#fff;border:none;border-radius:0;font-size:13px;font-weight:600;cursor:pointer;margin-top:8px;font-family:var(--fb);letter-spacing:.08em;text-transform:uppercase;">Add to Bag</button>';
        sizesEl.appendChild(row2);
      }
    }
  }

  modal.style.display   = 'block';
  overlay.style.display = 'block';
  document.body.style.overflow = 'hidden';
  return true;
}

document.addEventListener('click', function(e) {
  var qa = e.target.closest('[data-qa]');
  if (!qa) return;

  /* Desktop: let native <a> handle navigation — don't intercept */
  if (window.innerWidth > 900) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  var card = qa.closest('article, .product-card');
  openQuickAddModal(card);
}, true); /* capture=true */

/* Close QA modal */
document.addEventListener('click', function(e) {
  if (e.target.id === 'qaClose' || e.target.id === 'qaOverlay' || e.target.closest('#qaClose')) {
    document.getElementById('qaModal').style.display   = 'none';
    document.getElementById('qaOverlay').style.display = 'none';
    document.body.style.overflow = '';
  }
});

/* Add to bag from QA modal */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.qa-sz-add[data-vid]');
  if (!btn) return;
  e.preventDefault();
  var vid  = parseInt(btn.dataset.vid);
  if (!vid) return;
  var orig = btn.innerHTML;
  btn.textContent = '…';
  btn.disabled = true;
  cartAdd(vid, 1,
    function() {
      cartGet(function(c){ renderCart(c); });
      if (window.openCart) openCart();
      /* Close modal */
      document.getElementById('qaModal').style.display   = 'none';
      document.getElementById('qaOverlay').style.display = 'none';
      document.body.style.overflow = '';
      var t = document.createElement('div');
      t.className = 'pe-toast-msg';
      t.textContent = (window.PE_T?window.PE_T('added_bag','Added to bag ✓'):'Added to bag ✓');
      document.body.appendChild(t);
      setTimeout(function(){ if(t.parentNode) t.remove(); }, 2500);
    },
    function() { btn.innerHTML = orig; btn.disabled = false; }
  );
});

/* Close on outside click */
document.addEventListener('click', function(e) {
  if (!e.target.closest('.pc-sizes') && !e.target.closest('[data-qa]')) {
    var open = document.querySelectorAll('.pc-sizes.pc-sizes--open');
    if (open.length) { closeAllPanels(); document.body.style.overflow = ''; }
  }
});

/* v34: cor escolhida no cartao (bolinhas/miniaturas) */
document.addEventListener('click', function(e) {
  var t = e.target.closest && e.target.closest('.pc-vthumb');
  if (!t) return;
  var card = t.closest('article, .product-card'); if (!card) return;
  card.querySelectorAll('.pc-vthumb').forEach(function(b){ b.classList.toggle('on', b === t); });
});
/* v34: produtos com varias cores - a variante tem de ser a da cor escolhida (ou a da foto principal).
   Devolve: id da variante, 0 se essa cor/tamanho esta esgotado, ou null se o produto nao tem cores. */
function peCardVariant(card, rawSize) {
  var vars = [];
  try { vars = JSON.parse(card.dataset.variants || '[]'); } catch (_) {}
  var cols = {}; vars.forEach(function(v){ if (v.color) cols[v.color] = 1; });
  if (Object.keys(cols).length < 2) return null;
  var on = card.querySelector('.pc-vthumb.on');
  var col = on ? on.dataset.color : (card.dataset.color0 || '');
  for (var i = 0; i < vars.length; i++) {
    var v = vars[i];
    if (v.color === col && v.available && (rawSize == null || v.size === rawSize)) return v.id;
  }
  return 0;
}

/* ── Size → Cart ── */
document.addEventListener('click', function(e) {
  var sz = e.target.closest('.pc-sz:not(.pc-sz-oos):not(.pc-sz-more)');
  if (sz) {
    e.preventDefault(); e.stopPropagation();
    var vid = parseInt(sz.dataset.vid);
    var cardV = sz.closest('article, .product-card');
    var cv = cardV ? peCardVariant(cardV, sz.dataset.raw != null ? sz.dataset.raw : sz.dataset.sz) : null;
    if (cv === 0) { msg((window.PE_T?window.PE_T('sold_out','Sold out'):'Sold out')); return; }
    if (cv) vid = cv;
    if (!vid) return;
    sz.disabled = true;
    var orig = sz.textContent.trim(); sz.textContent = '…';
    cartAdd(vid, 1,
      function() {
        cartGet(function(c) { renderCart(c); });
        if (window.openCart) openCart();
        msg((window.PE_T?window.PE_T('added_bag','Added to bag ✓'):'Added to bag ✓'));
        sz.textContent = orig; sz.disabled = false;
        closeAllPanels(); document.body.style.overflow = '';
      },
      function() { sz.textContent = orig; sz.disabled = false; }
    );
    return;
  }
  var atc = e.target.closest('.pc-sizes-atc');
  if (atc) {
    e.preventDefault(); e.stopPropagation();
    var vid2 = parseInt(atc.dataset.atc);
    var cardA = atc.closest('article, .product-card');
    var cv2 = cardA ? peCardVariant(cardA, null) : null;
    if (cv2 === 0) { msg((window.PE_T?window.PE_T('sold_out','Sold out'):'Sold out')); return; }
    if (cv2) vid2 = cv2;
    if (!vid2) return;
    atc.disabled = true;
    var orig2 = atc.textContent.trim(); atc.textContent = '…';
    cartAdd(vid2, 1,
      function() {
        cartGet(function(c) { renderCart(c); });
        if (window.openCart) openCart();
        msg((window.PE_T?window.PE_T('added_bag','Added to bag ✓'):'Added to bag ✓'));
        atc.textContent = orig2; atc.disabled = false;
        closeAllPanels(); document.body.style.overflow = '';
      },
      function() { atc.textContent = orig2; atc.disabled = false; }
    );
  }
});

/* ── img-loaded ── */
function initImgLoaded() {
  document.querySelectorAll('.pc-img-main').forEach(function(img) {
    var m = img.closest('.pc-media');
    if (!m) return;
    if (img.complete && img.naturalWidth > 0) m.classList.add('img-loaded');
    else {
      img.addEventListener('load',  function() { m.classList.add('img-loaded'); });
      img.addEventListener('error', function() { m.classList.add('img-loaded'); });
    }
  });
}

/* ── Pscroll ── */
function initPscroll() {
  document.querySelectorAll('.pscroll-wrap,.pscroll-rail,.pscroll-outer').forEach(function(w) {
    if (w._ps) return; w._ps = true;
    var down = false, sx = 0, sl = 0;
    w.addEventListener('mousedown',  function(e) { down=true; sx=e.pageX-w.offsetLeft; sl=w.scrollLeft; w.style.cursor='grabbing'; });
    w.addEventListener('mouseleave', function() { down=false; w.style.cursor=''; });
    w.addEventListener('mouseup',    function() { down=false; w.style.cursor=''; });
    w.addEventListener('mousemove',  function(e) { if(!down)return; e.preventDefault(); w.scrollLeft=sl-(e.pageX-w.offsetLeft-sx)*1.3; });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  syncWL();
  initImgLoaded();
  initPscroll();
  window.initImgLoaded = initImgLoaded;
});

})();